import demoBypass from './bypass';
import { hasQueryParam, getParamFromQueryString } from '../helpers/queryParams';
import ourLocalStorage from '../storage/localStorage';

const iframe = (() => {
  const $iframe = $('iframe[name="leadsquared_landing_page_frame"]');
  const leadsquaredIframeWindow = $iframe[0].contentWindow;

  return {
    updateHeight: (height) => {
      $iframe.attr('height', height);
    },

    postToIframe: (data) => {
      leadsquaredIframeWindow.postMessage(data, '*');
    },

    setSrcToLeadsquaredLandingPage: () => {
      /**
      * function sets the src attribute in the leadsquare iframe
      * once it loads this page will trigger a message via the
      * window.postMessage API which is captured by EventListener
      * attached by contentGateVersionTwo below
      */
      $iframe.attr('src', window.contentGateDetails.leadsquaredUrl);
    },
  };
})();

/**
 * This is separate so some of our gate functionality works in preview mode
 * and prevents data logging in google analytics from running.
 * @param {object} e event object from window.message
 * @param {*} gateInfo javascript variables for content gate
 */
const previewEventHandler = (e, gateInfo) => {
  if (e.data.message === 'publicationInformationRequest') {
    const data = {
      message: 'publicationDataSent',
      publication: gateInfo.siteName,
      topics: gateInfo.contentTopics,
    };
    iframe.postToIframe(data);
  }

  if (e.data.message === 'contentGateLoaded') {
    window.contentGateVersionTwo.showGate();
    iframe.updateHeight(e.data.height);
  }
};

window.contentGateVersionTwo = {
  contentGateData: window.contentGateDetails,
  // default ex date. Previous version of content gate takes into account that this might change
  expiryDays: 60,

  submissionFormData: {},

  /**
   * Runs on load. Bind our events and gives the demobypass a callback for the toggler.
   * Add the bypass div to the top of the page.
   */
  init() {
    this.bindEvents();
    if (this.hasClientDemoQueryParam()) {
      demoBypass.toggleCallback = this.toggleClientDemoGate.bind(this);
      demoBypass.addToTop();
    }
  },

  bindEvents() {
    $('#content-gate-bypass').on('click', () => {
      demoBypass.toggle();
    });

    $('.bypass').on('dblclick', (e) => {
      this.attemptBypassGate(e.target);
    });
  },

  /**
   * Function used for the demo bypass toggle. Toggles classes "client-demo active-gate" class.
   * Will re add gate if hidden and hide gate if not hidden
   */
  toggleClientDemoGate() {
    // hide show bypass row for gate.
    const isGateHidden = $('.gate').is(':hidden');
    const clientDemoCssClass = 'client-demo active-gate';
    $('.menu-wrapper.desktop').toggleClass(clientDemoCssClass);
    $('.menu-wrapper.mobile').toggleClass(clientDemoCssClass);
    $('.mobile-logo').toggleClass(clientDemoCssClass);
    $('.menu-trigger').toggleClass(clientDemoCssClass);
    if (isGateHidden) {
      this.reapplyGate();
    } else {
      this.hideGate();
    }
  },

  /**
   * Removes the element after double click. It will hide the gate if both buttons are removed.
   * @param {obj} element - JQuery element or string to select element
   */
  attemptBypassGate(element) {
    // Remove the element being clicked on
    $(element).remove();
    // if there are no more elements to be clicked, dismiss the gate
    if ($('.bypass').length === 0) {
      this.hideGate();
    }
  },

  removeBypass() {
    $('.bypass').remove();
  },

  hasClientDemoQueryParam() {
    return hasQueryParam('client_demo');
  },

  hasNoGateQueryParam() {
    return hasQueryParam('nogate');
  },

  hasCrossDiveCoRegParam() {
    return hasQueryParam('coreg');
  },

  isLyticsTagLoaded() {
    return 'jstag' in window && 'send' in window.jstag;
  },

  sendDataToLytics(data, stream = '') {
    if (this.isLyticsTagLoaded()) {
      if (stream === '') {
        window.jstag.send(data);
      } else {
        window.jstag.send(stream, data);
      }
    }
  },

  /**
   * Gets the LeadSquared landing page's slug used for the content gate
   * @return {String} the landing page slug or the empty string (which denotes an error)
   */
  getLeadsquaredSlug() {
    if ('leadsquaredUrl' in this.contentGateData) {
      // create an a tag so we can use built in JS functionality to get the pathname
      const parser = document.createElement('a');
      parser.href = this.contentGateData.leadsquaredUrl;
      // strip the leading slash off of the pathname to get our slug
      return parser.pathname.substring(1);
    }

    return '';
  },

  shouldShowContentGate(contentType, contentId) {
    // In the future, we will decide here whether to show the content gate after
    // submission but right now we need to return true for the `head.html`
    // to get everything working
    return contentType && contentId;
  },

  getLocalStorageKey(contentType, contentPK) {
    return `content_gate_allow_access_${contentType}_${contentPK}_v2`;
  },

  handleCoregParam(contentType, contentId) {
    // hide the coreg=true url param if it's present
    // and determine whether to submit the gate and hide it or just hide it
    let currUrl = '';
    let newUrl = '';
    if (this.hasCrossDiveCoRegParam()) {
      if (window.location.search.indexOf('coreg') !== -1) {
        currUrl = window.location.href;
        // remove the param and then any trailing question mark or ampersand
        newUrl = currUrl.replace(/coreg=[^&]*&?/gi, '').replace(/[?&]+$/, '');
        window.history.replaceState({}, document.title, newUrl);
      }

      // When the coreg param is present, submit the gate and hide it
      // or only hide it if it's already been submitted i.e if localstorage key is present
      if (this.hasValidLocalStorage(contentType, contentId)) {
        this.hideGate();
      } else {
        this.saveGateSubmission();
        this.hideGate();
      }
    }
  },
  /**
   * Capstone method to filter out potential messages into ones that the contentGate API cares.
   * Calls other operational methods from contentGate API depending on the event.
   * @param {String} eventName
   * @param data
   */
  listenForEvents(eventName, data) {
    const {
      siteName,
      contentTopics,
      contentType,
      contentId,
    } = this.contentGateData;
    // Hide the gate when:
    // 1. The gated content was associated with a coreg offer
    // 2. The user has filled out the form , we reward the user and don't show the gate,
    //    given that it's not a client demo
    // 3. The content's url donsn't have ?nogate=true (3rd party promotion)
    //    or ?preview_no_gate (when previewing the trendline in the admin)
    // However, we show the gate on the client demo, even if the user has submitted the form
    if (eventName === 'contentGateLoaded') {
      if (this.hasValidLocalStorage(contentType, contentId)
        && !this.hasClientDemoQueryParam()) {
        this.hideGate();
      } else if (this.hasNoGateQueryParam()
        || this.hasPreviewNoGateQueryParam(contentType, contentId)) {
        this.hideGate();
      } else {
        this.showGate();
        this.limitTrendineDisplay();
        iframe.updateHeight(data.height);
        this.postQueryStringToIframe(this.queryString);

        // Push Gate Shown event event to GA4
        const eventObject = {
          event: 'trendline_gate_shown',
          trendline_gate_shown: {
            v: 12,
            name: 'Trendline Gate Shown',
          },
        };
        window.pushGTMEvent(eventObject);
      }

      // if there's a coreg=true param url, hide it and submit/hide the gate
      this.handleCoregParam(contentId, contentType);
    } // end contentGateLoaded event

    // Sends the publication to the Leadsquared form. This is only for the default house gate.
    // It's a catch-all gate for content that had a sponsored campaign, but doesn't one at the
    // current time.
    if (eventName === 'publicationInformationRequest') {
      const postData = {
        message: 'publicationDataSent',
        publication: siteName,
        topics: contentTopics,
      };
      iframe.postToIframe(postData);
    } // end publicationInformationRequest event

    if (eventName === 'publicationInformationFinished') {
      // To send the lytics segmants, we first need to make sure that the dive publication is set
      // "publicationDataSent" will update the default gate's dive publication. After
      // that is completed, "publicationInformationFinished"
      // is posted back and sends back the lytics segments.
      // If it is not the default gate, this will run instead of "publicationInformationRequest"
      if (window.liosetup) {
        window.liosetup.addEntityLoadedCallback(() => {
          this.sendLyticsSegments(window.lio.data.segments);
        });
      }
    } // end publicationInformationFinished event
    /**
     * Persist the form data before it gets validated. We don't want to
     * save it to local storage in the iFrame as it could be blocked by privacy settings.
     */
    if (eventName === 'contentGateFormData') {
      this.submissionFormData = data.formData;
    } // end contentGateFormData event

    // Handles what to do with the gate after submission like
    // sending analytics data to Lytics and GAM
    if (eventName === 'contentGateSubmitted') {
      // On the client demo page, we prevent the data from being submitted and just toggle the gate
      // and remove the bypass.
      if (this.hasClientDemoQueryParam()) {
        demoBypass.toggle();
        this.removeBypass();
        return;
      }

      this.hideGate();
      this.saveGateSubmission();

      // We want to send submission data to lytics
      const form = this.submissionFormData;

      this.sendDataToLytics({
        email: form.EmailAddress,
        first_name: form.FirstName,
        last_name: form.LastName,
        company_name: form.Company,
        company_type: form.mx_Company_Type,
        job_function: form.mx_Job_Function,
        job_level: form.mx_Job_Level,
      });

      // And also record a lytics event to indicate that they submitted this content gate
      const landingPageSlug = this.getLeadsquaredSlug();

      if (landingPageSlug !== '') {
        this.sendDataToLytics({
          content_type: this.contentGateData.contentType,
          landing_page_slug: landingPageSlug,
        },
        'content_gate_submissions');
      }

      // Data to push to GA4
      const eventObject = {
        event: 'user.trendlineGateSubmission',
        'user.trendlineGateSubmission': {
          v: 12, // <-- DO NOT EDIT. Seer version number
          name: 'Trendline Gate Submission',
        },
      };

      window.pushGTMEvent(eventObject);
    } // end contentGateSubmitted event

    if (eventName === 'contentGateError') {
      // errors from contentGate are propagated from
      // leadsquared landing page js via parent.postMessage
      // https://github.com/industrydive/leadsquared-tools/blob/master/includes/js/content-gate-head.js
      // we then send these errors to bugsnag
      const errorMessage = 'contentGateError '.concat(JSON.stringify(data));
      window.bugsnagClient.notify(new Error(errorMessage));
    } // end contentGateError event
  },
  /**
   * Restrict visible elements on trendline:
   * - blur out the main header image
   * - prevent scrolling beyond the below the gate
   */
  limitTrendineDisplay() {
    $('.main-header-image').css('filter', 'blur(0.25rem)');
    $('.page-inner-wrapper').css({
      position: 'fixed',
      width: '100%',
    });
  },
  /**
   * shows the gate.
   * NOTE: We're using hide() which sets display: none as well as
   * visibility: hidden/visible. hide() is being used to hide the gate after
   * submission. But the gate is being hidden by default with visibility: hidden
   * and that's preventing it from flashing for a sec on a subsequent visit after
   * submission. I tried using show() to show the gate and stay consistent with
   * how using hide() to hide it, but that didn't seem to work. With show(), I'd
   * have to set .gate to display: none. Doing that seems to make the height from
   * the contentGateLoaded event 0, even though it's supposed to be
   * $('body').height() and that's causing the iframe's height to be 0 and not
   * showing on the gate.
   */
  showGate() {
    $('.gate').css('visibility', 'visible');
  },
  /**
   * Hide the gate. Position the scroll bar at the top. Return wrapper to static position.
   * Run when "contentGateSubmitted" event is sent to window.
   * Shouldn't need to resize the gate this time.
   */
  hideGate() {
    $('.gate').hide();
    $(window).scrollTop(0);
    $('.main-header-image').css({
      filter: 'none',
    });
    $('.page-inner-wrapper').css({
      position: 'static',
    });
    $('.social-buttons, .menu-trigger').css('visibility', 'visible');
    this.removeBypass();
    $('.menu-trigger').removeClass('hide-small');

    // the gate changes the height of the screen, these need to be updated for
    // the progress bars to work correctly.
    window.trendline.setConstants();
    window.trendline.setUIVariables();
    window.trendline.replaceAdTokenWithAd();
  },

  /**
   * Reapplies the gate on the client demo after it is bypassed.
   * The statements have an order to them.
   */
  reapplyGate() {
    $('.menu-close').trigger('click');
    $('.gate').show();
    this.limitTrendineDisplay();
    $('.menu-trigger').addClass('hide-small');
    $(window).scrollTop(0);
  },
  /**
   * Saves content gate submission details to local storage
   * @param {number} expiryDays // Date access expires (60 days after submission)
   */
  saveGateSubmission(expiryDays = this.expiryDays) {
    const {
      gateId,
      sponsoredCampaignId,
      leadsquaredUrl,
      contentType,
      contentId,
    } = this.contentGateData;

    const key = this.getLocalStorageKey(
      contentType, contentId,
    );

    const saveObject = {
      gateId,
      sponsoredCampaignId,
      leadsquaredUrl,
      expiryDays,
      timestamp: Date.now(),
    };

    ourLocalStorage.setItem(key, JSON.stringify(saveObject));
  },
  /**
   * Checks if the previous gate submission has expired i.e
   * the 60 days have passed along with that it also checks
   * whether the current sponsored campaign on the
   * trendline matched the campaign that was previously submitted
   * @param {number} startDate // Date the localstorage key was generated
   * @param {number} expiryDays // Date access expires (60 days after submission)
   * @param {number} savedSponsoredCampaignId // the SponsoredCampaignId saved
   * in the localstorage key
   */
  isSubmissionExpired(startDate, expiryDays, savedSponsoredCampaignId) {
    const { sponsoredCampaignId } = this.contentGateData;
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const today = Date.now();
    const totalDays = expiryDays * millisecondsPerDay;
    const dateDifference = today - totalDays;

    const isSponsoredCampaignId = savedSponsoredCampaignId === sponsoredCampaignId;

    if (isSponsoredCampaignId && (dateDifference <= startDate)) {
      return false;
    }
    return true;
  },
  /**
   * Checks if the localstorage key for saved gate information exists and whether it's valid
   * @param {string} contentType // the content type to be gate e.g trendline
   * @param {number} contentPK // content ID e.g trendline ID
   */
  hasValidLocalStorage(contentType, contentPK) {
    const localStorageKey = this.getLocalStorageKey(contentType, contentPK);
    const localStorageValue = ourLocalStorage.getItem(localStorageKey);

    if (localStorageValue) {
      const { timestamp, expiryDays, sponsoredCampaignId } = localStorageValue;
      const isExpired = this.isSubmissionExpired(timestamp, expiryDays, sponsoredCampaignId);
      if (!isExpired) {
        return true;
      }
    }
    return false;
  },

  /**
   * Send the utm parameters to the child iframe to be tracked with the lead
   * @param  {String} queryString
   */
  postQueryStringToIframe() {
    const data = {
      message: 'queryStringSent',
      queryString: window.location.search,
    };
    iframe.postToIframe(data);
  },
  /**
   * Send the Lytics segments to the child iframe
   * @param {String[]} lyticsSegments: window.lio.data.segments passed from divesite
   */
  sendLyticsSegments(lyticsSegments) {
    const data = {
      message: 'lyticsSegmentsSent',
      lyticsSegments,
    };
    iframe.postToIframe(data);
  },
  hasPreviewNoGateQueryParam(contentType, contentPK) {
    const hasParamValue = getParamFromQueryString('preview_no_gate');
    return hasParamValue === `${contentType}_${contentPK}`;
  },
  /**
   * check if an empty key was set from a coreg offer to access a trendline
   * without a gate then populate the empty key by saving the gate data and
   * hiding it
   * @param {string} contentType: the content type to be gate e.g trendline
   * @param {number} contentPK: content ID e.g trendline ID
   */
};

// The initialize function runs on load. Its binds the events
// and places a bypass dive a the top of the page. Our JS linter
// does not allow hoisting, which is why this is at the bottom
window.contentGateVersionTwo.init();
window.addEventListener('message', (e) => {
  if (window.contentGateDetails.isPreview) {
    const gateDetails = window.contentGateDetails;
    previewEventHandler(e, gateDetails);
  } else {
    window.contentGateVersionTwo.listenForEvents(e.data.message, e.data);
  }
});
/**
* Once contentGateVersionTwo has attached an EventListener
* we are now ready to set the leadsquared landing page source
*/
iframe.setSrcToLeadsquaredLandingPage();
